"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InputTextForm_1 = __importDefault(require("@Fields/v2/InputTextForm"));
const react_1 = __importDefault(require("react"));
require("./index.scss");
const MfaForm = (props) => {
    const { codeField, mfaType, mfaContactPoint } = props;
    const isMfaEmail = mfaType === 'email';
    return (react_1.default.createElement("div", { className: 'header' },
        react_1.default.createElement("h2", null,
            "Confirm ",
            isMfaEmail ? 'Email ' : 'Phone ',
            " MFA"),
        react_1.default.createElement("p", null,
            "We have ",
            isMfaEmail ? 'emailed ' : 'texted ',
            " a code to ",
            mfaContactPoint),
        react_1.default.createElement("p", null, "Please enter that code in the space below"),
        react_1.default.createElement("p", { className: 'disclaimer' }, "NOTE: MFA codes expire after 15 minutes"),
        react_1.default.createElement(InputTextForm_1.default, Object.assign({}, codeField))));
};
exports.default = MfaForm;
